"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../constants");
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var Button = function Button(_ref) {
  var id = _ref.id,
    text = _ref.text,
    onClick = _ref.onClick,
    type = _ref.type,
    disabled = _ref.disabled,
    buttonType = _ref.buttonType,
    link = _ref.link,
    external = _ref.external,
    icon = _ref.icon,
    iconFlip = _ref.iconFlip,
    buttonSize = _ref.buttonSize,
    fullWidth = _ref.fullWidth,
    active = _ref.active,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    iconClassName = _ref.iconClassName,
    notificationBackground = _ref.notificationBackground;
  if (link) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: link,
      external: external,
      disabled: disabled,
      style: style,
      id: id,
      className: (0, _classnames["default"])('btn', iconFlip && 'flex-row-reverse', disabled ? _constants.BUTTON_TYPES.DISABLED : buttonType || _constants.BUTTON_TYPES.PRIMARY, fullWidth && _constants.BUTTON_FEATURES.FULL_WIDTH, active && 'active', buttonSize, className)
    }, icon && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-shrink-0', 'flex', text && !iconFlip && 'margin-right-sm', text && iconFlip && 'margin-left-sm')
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: icon,
      className: iconClassName
    })), text, children);
  }
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: type,
    disabled: disabled,
    onClick: onClick,
    style: style,
    className: (0, _classnames["default"])('btn', iconFlip && 'flex-row-reverse', disabled ? _constants.BUTTON_TYPES.DISABLED : buttonType || _constants.BUTTON_TYPES.PRIMARY, fullWidth && _constants.BUTTON_FEATURES.FULL_WIDTH, active && 'active', buttonSize, className)
  }, icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-shrink-0', 'flex', text && !iconFlip && 'margin-right-sm', text && iconFlip && 'margin-left-sm', 'position-relative')
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: icon,
    className: iconClassName
  }), notificationBackground && /*#__PURE__*/_react["default"].createElement("span", {
    className: "notification ".concat(notificationBackground, " text-xxs d8-u-text-semi-bold d8-u-color-white")
  })), text, children);
};
Button.propTypes = {
  type: _propTypes["default"].string,
  buttonType: _propTypes["default"].string,
  text: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  onClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  link: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  buttonSize: _propTypes["default"].string,
  className: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  iconFlip: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  external: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  children: _propTypes["default"].any,
  iconClassName: _propTypes["default"].string,
  notificationBackground: _propTypes["default"].string
};
Button.defaultProps = {
  type: 'button',
  text: '',
  disabled: false,
  buttonSize: '',
  className: '',
  fullWidth: false,
  iconFlip: false,
  onClick: null,
  buttonType: _constants.BUTTON_TYPES.PRIMARY,
  link: null,
  icon: null
};
var _default = exports["default"] = Button;